<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col
                no-gutters    
                cols="12"
                :md="showNotes ? '6' : '12'">
            <v-card v-if="populating == false && populatingFailure == false">
                <v-card-title class="pb-3">Claim #{{ claim.id }}</v-card-title>
                <v-card-text>
                    <v-container
                        class="py-0"
                        fluid
                    >
                        <v-form
                            ref="claimForm"
                            v-model="isValid"
                        >
                            <v-row class="pb-0">
                                <v-col
                                    class="py-0"
                                    cols="12"
                                >
                                    <FileUploadDragNDrop
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="POD"
                                        placeholder="Set POD Document"
                                        v-model="podFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.podFileId, 'pod')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.podFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </FileUploadDragNDrop>
                                </v-col>
                                <v-col
                                    class="py-0"
                                    cols="12"
                                    v-show="claim.podFileId > 0 || podFile"
                                >
                                    <v-select
                                        :disabled="isLoading"
                                        :items="users"
                                        clearable
                                        :rules="[assignedUserRule]"
                                        item-text="value"
                                        item-value="key"
                                        label="Assigned User"
                                        v-model="claim.assignedUserId"
                                    ></v-select>
                                </v-col>
                                <v-col
                                    class="py-0"
                                    cols="12"
                                    v-show="claim.queryLetterFileId > 0"
                                >
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Resubmission POD"
                                        placeholder="Set Resubmission POD Document"
                                        v-model="resubmissionPodFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.resubmissionPodFileId, 'rpod')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.resubmissionPodFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col
                                    class="py-0"
                                    cols="12"
                                >
                                    <v-text-field
                                        :disabled="isLoading || !(claim.podFileId > 0)"
                                        :rules="[lengthRule(50)]"
                                        label="Link Number"
                                        v-model="claim.linkNumber"
                                    ></v-text-field>
                                </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            :disabled="isLoading"
                                            :items="statuses"
                                            :rules="[requiredIfLinkNumber]"
                                            clearable
                                            item-text="value"
                                            item-value="key"
                                            label="Status"
                                            v-model="claim.status"
                                        ></v-select>
                                    </v-col>
                            </v-row>
                            <v-row class="pb-0">
                                <v-col
                                    class="py-0"
                                    cols="8"
                                >
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf, text/plain"
                                        label="Objection Letter/Note"
                                        placeholder="Set Objection Letter/Note"
                                        v-model="objectionLetterFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.objectionLetterFileId, 'objection-letter')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.objectionLetterFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col
                                    class="py-0"
                                    cols="4"
                                >
                                    <v-switch
                                        :disabled="isLoading || (!claim.objectionLetterFileId && !objectionLetterFile)"
                                        class="mb-0"
                                        label="Objection Resolved"
                                        v-model="claim.isObjectionResolved"
                                    ></v-switch>
                                </v-col>

                                <v-col
                                    class="py-0"
                                    cols="8"
                                >
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf, text/plain"
                                        label="Rejection Letter/Note"
                                        placeholder="Set Repudiated Letter/Note"
                                        v-model="rejectionLetterFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.rejectionLetterFileId, 'rejection-letter')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.rejectionLetterFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col
                                    class="py-0"
                                    cols="4"
                                >
                                    <v-switch
                                        :disabled="isLoading || (!claim.rejectionLetterFileId && !rejectionLetterFile)"
                                        class="mb-0"
                                        label="Repudiated Resolved"
                                        v-model="claim.isRejectionResolved"
                                    ></v-switch>
                                </v-col>

                                <v-col
                                    class="py-0"
                                    cols="8"
                                    v-show="claim.podFileId > 0 && !(claim.linkNumber > 0 && !(claim.queryLetterFileId > 0))"
                                >
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf, text/plain"
                                        label="Query Letter/Note"
                                        placeholder="Set Query Letter/Note"
                                        v-model="queryLetterFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.queryLetterFileId, 'query-letter')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.queryLetterFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                </v-col>
                                <v-col
                                    class="py-0"
                                    cols="4"
                                    v-show="claim.podFileId > 0 && !(claim.linkNumber > 0 && !(claim.queryLetterFileId > 0))"
                                >
                                    <v-switch
                                        :disabled="isLoading"
                                        readonly
                                        class="mb-0"
                                        label="Query Resolved"
                                        v-model="isQueryResolved"
                                    ></v-switch>
                                </v-col>
                            </v-row>
                            <v-row class="pb-0">
                                <v-col cols="12">
                                    <v-text-field
                                        label="Total Amount Claimed"
                                        min="0"
                                        prefix=" R"
                                        readonly
                                        type="number"
                                        v-model.number="totalAmountClaimed"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :disabled="isLoading"
                                        label="Payment Received"
                                        min="0"
                                        prefix="-R"
                                        type="number"
                                        v-model.number="claim.paymentReceived"
                                        @change="paymentReceivedChanged"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-switch
                                        :disabled="isLoading || !claim.isFinal"
                                        label="Is Final"
                                        v-model="claim.isFinal"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        label="Balance"
                                        min="0"
                                        prefix=" R"
                                        readonly
                                        type="number"
                                        v-model.number="calculatedBalance"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <!-- payment status sections-->
                            <v-row v-show="calculatedBalance == 0">
                                <v-col cols="12" v-if="!claim.accounts.some(x => x.hasAdminFunding) && claim.accounts.some(x => x.hasPrefundFunding)">
                                    <v-switch
                                        :disabled="isLoading"
                                        class="mb-0"
                                        label="Prefund Yes"
                                        v-model="claim.isPaidFullPrefund"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" v-if="claim.accounts.some(x => x.hasAdminFunding) && claim.accounts.some(x => x.hasPrefundFunding)">
                                    <v-switch
                                        :disabled="isLoading"
                                        class="mb-0"
                                        label="Admin/Prefund Yes"
                                        v-model="claim.isPaidFullAdmin"
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" v-if="claim.accounts.some(x => x.hasAdminFunding) && !claim.accounts.some(x => x.hasPrefundFunding)">
                                    <v-switch
                                        :disabled="isLoading"
                                        class="mb-0"
                                        label="Admin Yes"
                                        v-model="claim.isPaidFullAdmin"
                                    ></v-switch>
                                </v-col>
                                <template v-if="claim.accounts.some(x => x.hasAdminFunding)">
                                    <v-col cols="12">
                                        <v-file-input
                                            :disabled="isLoading"
                                            accept="image/png, image/jpeg, image/bmp, application/pdf"
                                            label="Admin Remittance sent to SP"
                                            placeholder="Set admin remittance"
                                            v-model="adminRemittanceSentFile"
                                        >
                                            <template slot="append-outer">
                                                <v-btn
                                                    @click.stop="getClaimFile(claim.adminRemittanceSentFileId, 'adminremit')"
                                                    elevation="1"
                                                    fab
                                                    small
                                                    v-show="claim.adminRemittanceSentFileId > 0"
                                                >
                                                    <h3>
                                                        <v-icon color="light-blue">mdi-download</v-icon>
                                                    </h3>
                                                </v-btn>
                                            </template>
                                        </v-file-input>
                                        <v-spacer></v-spacer>
                                        <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Admin remittance sent"
                                            v-model="claim.isAdminRemittanceSent">
                                        </v-switch>
                                        </v-col>
                                </template>
                            </v-row>

                            <v-row v-show="calculatedBalance > 0 && claim.paymentReceived > 0" && >


                            
                                <v-col cols="12">                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Short Payment Form"
                                        placeholder="Set short payment form"
                                        v-model="shortPaymentFormFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.shortPaymentFormFileId, 'shortpayform')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.shortPaymentFormFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                <v-spacer></v-spacer>
                                <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Short payment form set"
                                            v-model="claim.isShortPaymentFormSent">
                                </v-switch>
                                        <v-expand-transition>
                                            <v-textarea
                                                :rules="[ requiredShortPaymentFormSetRule, lengthRule(512)]"
                                                counter
                                                label="Status Change Reason"
                                                v-model="claim.shortPaymentFormSetText"
                                                v-show="showShortPaymentFormSetInput"
                                            ></v-textarea>
                                        </v-expand-transition>
                            </v-col>
                            <v-col cols="12" v-show="claim.isShortPaymentFormSent && (claim.shortPaymentFormFileId > 0 || shortPaymentFormFile)">
                                    <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Decision Taken & Note Made"
                                            v-model="claim.isDecisionTakenNoteMade">
                                </v-switch>
                                        <v-expand-transition>
                                            <v-textarea
                                                :rules="[ requiredDecisionTakenNoteRule, lengthRule(512)]"
                                                counter
                                                label="Status Change Reason"
                                                v-model="claim.decisionTakenNoteText"
                                                v-show="showDecisionTakenNoteInput"
                                            ></v-textarea>
                                        </v-expand-transition>
                            </v-col>

                            <v-col cols="12" v-show="claim.isShortPaymentFormSent && (claim.shortPaymentFormFileId > 0 || shortPaymentFormFile) && claim.isDecisionTakenNoteMade">
                                    <v-file-input
                                        :disabled="isLoading"
                                        accept="image/png, image/jpeg, image/bmp, application/pdf"
                                        label="Communication to SP"
                                        placeholder="Set communication to SP"
                                        v-model="commToSpFile"
                                    >
                                        <template slot="append-outer">
                                            <v-btn
                                                @click.stop="getClaimFile(claim.commToSpFileId, 'commtosp')"
                                                elevation="1"
                                                fab
                                                small
                                                v-show="claim.commToSpFileId > 0"
                                            >
                                                <h3>
                                                    <v-icon color="light-blue">mdi-download</v-icon>
                                                </h3>
                                            </v-btn>
                                        </template>
                                    </v-file-input>
                                <v-spacer></v-spacer>
                                                                <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Communication to SP sent"
                                            v-model="claim.isCommToSpSent">
                                </v-switch>
                            </v-col>

                            <v-col cols="12" v-show="claim.isShortPaymentFormSent && (claim.shortPaymentFormFileId > 0 || shortPaymentFormFile) && claim.isDecisionTakenNoteMade && claim.isCommToSpSent && (claim.commToSpFileId > 0 || commToSpFile)
                                ">
                                    <v-switch
                                            :disabled="isLoading"
                                            class="mb-0"
                                            label="Short Payment Action & Note Made"
                                            v-model="claim.isShortPayActionNoteMade">
                                </v-switch>
                                        <v-expand-transition>
                                            <v-textarea
                                                :rules="[ requiredShortPaymentActionNoteRule, lengthRule(512)]"
                                                counter
                                                label="Status Change Reason"
                                                v-model="claim.shortPaymentActionNoteText"
                                                v-show="showShortPaymentActionNoteInput"
                                            ></v-textarea>
                                        </v-expand-transition>
                            </v-col>

                        </v-row>

                        </v-form>
                        <v-row
                            align="end"
                            class="pt-0"
                            justify="end"
                            no-gutters
                        >
                            <v-btn
                                :disabled="isLoading && !isSaving"
                                :loading="isSaving"
                                @click="saveEntity"
                                class="text-none"
                                color="secondary darken-1"
                                text
                            >Update</v-btn>
                        </v-row>
                        <v-row class="pb-0">
                            <v-col
                                class="py-0"
                                cols="12"
                            >
                                <strong>Patient</strong>
                                <br />
                                Full Name: {{claim.patient.name + ' ' + claim.patient.surname }}
                                <br />
                                <!--{{getIdentityTypeName(claim.patient.identityTypeId) + ': ' + claim.patient.identificationNumber }}-->
                                {{'Identification Number: ' + claim.patient.identificationNumber }}
                                <br />
                                <br />
                                <strong>Provider</strong>
                                <br />
                                {{getProviderName(claim.providerId)}}
                            </v-col>
                        </v-row>
                        <v-row
                            :key="account.id"
                            v-for="account in claim.accounts"
                        >
                            <v-col cols="12">
                                <v-card>
                                    <v-row class="pa-0 ma-0">
                                        <v-col
                                            class="pa-0 ma-0"
                                            col="8"
                                        >
                                            <v-card-subtitle class="bp-0">
                                                <strong>Account #{{ account.id }}</strong>
                                            </v-card-subtitle>
                                        </v-col>
                                        <v-col
                                            class="text-right"
                                            col="4"
                                        ></v-col>
                                    </v-row>
                                    <v-card-text>
                                        <v-row class="py-0">
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >{{'Invoice: ' + account.invoiceNumber}}</v-col>
                                        </v-row>

                                        <v-row class="py-0" v-show="account.hasPrefundFunding">
                                            <v-col
                                                class="py-0 font-weight-bold"
                                                cols="12"
                                            >Prefund Funding</v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >{{'GRV: ' + account.grvNumberPrefund}}</v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Face Value: R {{
                                                account.faceValuePrefund.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                                }}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Payment Remit Advice: R {{
                                                account.paymentAmountPrefund.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                                }}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Purchase Value: R {{
                                                account.purchaseValuePrefund.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                                }}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Is Paid: {{account.isPaidPrefund?"Yes":"No"}}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                            <v-divider></v-divider>
                                            </v-col>
                                        </v-row>

                                        <v-row class="py-0" v-show="account.hasAdminFunding">
                                            <v-col
                                                class="py-0 font-weight-bold"
                                                cols="12"
                                            >Administered Funding</v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >{{'GRV: ' + account.grvNumberAdmin}}</v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Face Value: R {{
                                                account.faceValueAdmin.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                                }}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Payment Remit Advice: R {{
                                                account.paymentAmountAdmin.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                                }}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Purchase Value: R {{
                                                account.purchaseValueAdmin.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                                }}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                                Is Paid: {{account.isPaidAdmin?"Yes":"No"}}
                                            </v-col>
                                            <v-col
                                                class="py-0"
                                                cols="12"
                                            >
                                            <v-divider></v-divider>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                                <!--
                                        <AccountClaimDetailsForm
                                            :account-in="account"
                                            :key="account.id"
                                        />
                                -->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
        <v-row v-show="populating == true">
            <v-col
                class="text-center"
                cols="12"
            >
                <v-progress-circular
                    :size="50"
                    color="secondary"
                    indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                class="text-center"
                cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.</v-col>
        </v-row>
            </v-card>
            </v-col>
            <v-col                
                no-gutters
                cols="12"
                md="6">
                <v-col
                    cols="12"
                    v-show="claim.id > 0"
                >
                    <h3>
                        Files
                        <v-btn
                            :disabled="isLoading"
                            @click="newClaimFile"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>

                    <v-card
                        :key="claimFile.id"
                        @click="loadClaimFileForm(claimFile)"
                        class="mt-5"
                        no-gutters
                        v-for="claimFile in claimFiles"
                    >
                        <v-card-text class="py-0">
                            <v-row>
                                <v-col cols="8">
                                    {{
                                    claimFileTypes.find(
                                    (x) => x.key == claimFile.claimFileType
                                    )
                                    ? claimFileTypes.find(
                                    (x) => x.key == claimFile.claimFileType
                                    ).value
                                    : ""
                                    }}
                                    <br />
                                    Valid Until:
                                    {{ validUntilDisplay(claimFile.validUntil) }}
                                    <br />
                                    Verified:
                                    {{ claimFile.isVerified ? "Yes" : "No" }}
                                    <br />
                                    Verification Updated By:
                                    {{ getUserName(claimFile.verifiedByUserId)}}
                                </v-col>

                                <v-col
                                    align-self="center"
                                    class="text-center"
                                    cols="4"
                                >
                                    <v-btn
                                        @click.stop="
                      getFile(
                        claimFile.fileId,
                        claimFile.claimId +
                          '_' +
                          (claimFileTypes.find((x) => x.key == claimFile.claimFileType)
                            ? claimFileTypes
                                .find((x) => x.key == claimFile.claimFileType)
                                .value.split(' ')
                                .join('_')
                            : '')
                      )
                    "
                                        fab
                                    >
                                        <h3>
                                            <v-icon color="light-blue">mdi-download</v-icon>
                                        </h3>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    v-if="showNotes"
                    cols="12"
                    v-show="claim.id > 0"
                >
                    <h3>
                        Notes
                        <v-btn
                            :disabled="isLoading"
                            @click="newNoteShow = true"
                            class="text-none ml-2"
                            color="secondary darken-1"
                            fab
                            x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-card
                        :key="note.id"
                        class="mt-5"
                        no-gutters
                        v-for="(note,n) in claim.notes"
                    >
                        <v-card-subtitle>
                            {{ note.author }}
                            <br />
                            {{ note.createdAt }}
                        </v-card-subtitle>
                        <v-card-text style="white-space: pre-wrap;">{{ note.text }}
                        <span :key="s" v-for="(short,s) in noteShortcodes[n]">
                            <v-btn v-if="short.type == 'file'"
                                @click.stop="getFile(short.id,short.name)"
                                elevation="1"
                                fab
                                small
                            >
                                <h3>
                                    <v-icon color="light-blue">mdi-download</v-icon>
                                </h3>
                            </v-btn>
                        </span>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-col>
        </v-row>
            <v-dialog
                persistent
                v-model="newNoteShow"
                width="500px"
            >
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-textarea
                            :rules="[lengthRule(512)]"
                            counter
                            label="Note"
                            v-model="newNoteText"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            @click="
                () => {
                  newNoteShow = false;
                  newNoteText = '';
                }
              "
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="isLoading || newNoteAdding || newNoteText.length == 0"
                            :loading="newNoteAdding"
                            @click="newNoteAdd"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Add</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                persistent
                v-model="claimFileFormVisible"
                width="500px"
            >
                <ClaimFileForm
                    :claim-file-in="claimFileFormEntity"
                    :key="claimFileFormKey"
                    @close="closeClaimFileForm"
                    @deleted="deletedClaimFile"
                    @saved="savedClaimFile"
                />
            </v-dialog>
    </v-container>
</template>

<script>
import dateToString from "../../helpers/dateToString";
import uuid4 from "../../helpers/uuid4";
import FileUploadDragNDrop from "../FileUploadDragNDrop.vue";
import ClaimFile from "../../models/ClaimFile.model";
import ClaimFileForm from "../forms/ClaimFileForm";
export default {
    props: {
        claimIn: Object,
        claimId: Number,
        identityTypes: Array,
        providers: Array,
        showNotes: { type: Boolean, default: false}
    },
    components: {
        FileUploadDragNDrop,
        ClaimFileForm
        //
    },
    created: async function() {
        this.statuses = await this.$store.dispatch(
            "claims/getStatuses"
        );
        this.users = await this.$store.dispatch("users/getlist");
        this.claimFileTypes = await this.$store.dispatch(
            "claims/getFileTypes"
        );
        await this.loadClaim();
    },
    mounted: async function() {},

    computed: {
        calculatedBalance: function() {
            var balance = this.totalAmountClaimed - this.claim.paymentReceived;
            var roundedBalance = Math.round((balance + Number.EPSILON) * 100) / 100;
            //if(roundedBalance == 0 && this.claim.isFinal == false)
            //this.claim.isFinal = true;
            return roundedBalance;
        },
        isQueryResolved(){
            return this.claim.queryLetterFileId > 0 && (this.claim.linkNumber || this.claim.resubmissionPodFileId > 0)
        },
        showShortPaymentFormSetInput: function() {
            return (
                this.claim.isShortPaymentFormSent && this.oldIsShortPaymentFormSent !== this.claim.isShortPaymentFormSent
            );
        },
        showDecisionTakenNoteInput: function() {
            return (
                this.claim.isDecisionTakenNoteMade && this.oldIsDecisionTakenNoteMade !== this.claim.isDecisionTakenNoteMade
            );
        },
        showShortPaymentActionNoteInput: function() {
            return (
                this.claim.isShortPayActionNoteMade && this.oldIsShortPayActionNoteMade !== this.claim.isShortPayActionNoteMade
            );
        },
    },
    data() {
        return {
            claim: { accounts: [{}], patient: {}, notes: [] },
            claimFiles: [],
            claimUpdateId: 0,
            populating: true,
            populatingFailure: true,
            totalAmountClaimed: 0,
            podFile: null,
            objectionLetterFile: null,
            rejectionLetterFile: null,
            queryLetterFile: null,
            resubmissionPodFile: null,
            adminRemittanceSentFile: null,
            shortPaymentFormFile: null,
            commToSpFile: null,
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            isVerifyingRsaId: null,
            //notifyShow: null,
            //notifyMessage: null,
            //notifyColor: null,
            dateMenuPaidDate: false,
            requestId: uuid4(),
            assignedUserRule: v => !!v || (!this.podFile && !this.claim.podFileId) || "required",
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            requiredShortPaymentFormSetRule: v =>
                this.showShortPaymentFormSetInput == false ||
                v.trim().length > 0 ||
                "required",
            requiredDecisionTakenNoteRule: v =>
                this.showDecisionTakenNoteInput == false ||
                v.trim().length > 0 ||
                "required",
            requiredShortPaymentActionNoteRule: v =>
                this.showShortPaymentActionNoteInput == false ||
                v.trim().length > 0 ||
                "required",
            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",
            statuses:[],
            users:[],
            shortcodeMatchRegex: /(\[\/%)(.*?)(\/%])/g,
            shortcodeReadRegex: /(?<=\[\/%)(.*)(?=\/%])/g,
            noteShortcodes: [],
            claimFileTypes: [],
            claimFileFormKey: null,
            claimFileFormEntity: null,
            claimFileFormVisible: false,
            oldIsShortPaymentFormSent: false,
            oldIsDecisionTakenNoteMade: false,
            oldIsShortPayActionNoteMade: false,
        };
    },
    methods: {
        readNoteShortcodes()
        {
            this.noteShortcodes = []
            if(this.claim.notes)
            for (let index = 0; index < this.claim.notes.length; index++) {
                let matches = this.claim.notes[index].text.match(this.shortcodeMatchRegex);
                var matchesJson = [];
                if(matches)
                for (let match = 0; match < matches.length; match++) {
                    matchesJson.push(JSON.parse(matches[match].match(this.shortcodeReadRegex)[0]));
                }
                this.noteShortcodes.push(matchesJson);
                this.claim.notes[index].text = this.claim.notes[index].text.replace(this.shortcodeMatchRegex, "");
            }
        },
        paymentReceivedChanged()
        {
            if(this.calculatedBalance == 0)
            this.claim.isFinal = true;
        },
        requiredIfLinkNumber(v)
        {
            return this.claim.linkNumber && !v ? "required" : true
        },
        async loadClaim() {
            this.claim = { accounts: [{}], patient: {}, notes: [] };
            this.podFile = null;
            this.objectionLetterFile = null;
            this.rejectionLetterFile = null;
            this.queryLetterFile = null;
            this.resubmissionPodFile = null;

            this.adminRemittanceSentFile = null;
            this.shortPaymentFormFile = null;
            this.commToSpFile = null;

            if (this.claimUpdateId > 0 || (this.claimIn == null && this.claimId > 0)) {
                var requestId = (this.requestId = uuid4());
                var claimResponse = await this.$store.dispatch(
                    "claims/getclaimpostsubmissionformdto",
                    {
                        id: this.claimUpdateId > 0 ? this.claimUpdateId : this.claimId,
                        urlParameters: {showNotes: this.showNotes},
                        requestId: requestId
                    }
                );

                if (this.requestId == claimResponse.requestId) {
                    this.claim = claimResponse.data;
                    this.oldIsShortPaymentFormSent = this.claim.isShortPaymentFormSent;
                    this.oldIsDecisionTakenNoteMade = this.claim.isDecisionTakenNoteMade;
                    this.oldIsShortPayActionNoteMade = this.claim.isShortPayActionNoteMade;

                    this.claim.shortPaymentFormSetText = "";
                    this.claim.decisionTakenNoteText = "";
                    this.claim.shortPaymentActionNoteText = "";

                    this.populatingFailure = false;
                }
            } else {
                this.claim = this.claimIn;
                this.populatingFailure = false;
            }

            this.totalAmountClaimed = this.claim.totalAmountClaimed ?? 0;
            this.readNoteShortcodes();
            this.populating = false;

            if(this.claimUpdateId > 0 || this.claimId > 0)
            this.claimFiles = await this.$store.dispatch("claims/getClaimFiles", this.claimUpdateId > 0 ? this.claimUpdateId : this.claimId);
        },
        getProviderName(id) {
            var i = this.providers
                ? this.providers.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getIdentityTypeName(id) {
            var i = this.identityTypes
                ? this.identityTypes.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
        getClaimFile(fileId, name) {
            this.getFile(fileId, "claim#" + this.claim.id + name + fileId);
        },
        dateToString,
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedClaim) {
            this.$emit("saved", savedClaim);
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.$emit("notify", message, color);
        },
        validateForm() {
            this.isValid = this.$refs.claimForm.validate();
            return this.isValid;
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                if (!this.claim.faceValue) this.claim.faceValue = 0;

                var formdata = new FormData();
                formdata.append("PodFile", this.podFile);
                formdata.append(
                    "ObjectionLetterFile",
                    this.objectionLetterFile
                );
                formdata.append(
                    "RejectionLetterFile",
                    this.rejectionLetterFile
                );
                formdata.append(
                    "QueryLetterFile",
                    this.queryLetterFile
                );
                formdata.append(
                    "ResubmissionPodFile",
                    this.resubmissionPodFile
                );
                formdata.append(
                    "AdminRemittanceSentFile",
                    this.adminRemittanceSentFile
                );
                formdata.append(
                    "ShortPaymentFormFile",
                    this.shortPaymentFormFile
                );
                formdata.append(
                    "CommToSpFile",
                    this.commToSpFile
                );

                formdata.append("Model", JSON.stringify(this.claim));

                const parameters = {
                    id: this.claim.id,
                    formData: formdata
                };
                this.claimUpdateId = this.claim.id;
                this.$store
                    .dispatch(
                        "claims/updateClaimPostSubmissionDetails",
                        parameters
                    )
                    .then(
                        /*response*/() => {
                            this.notify("Claim successfully saved.", "success");
                            /*
                            this.claim.objectionLetterFileId =
                                response.objectionLetterFileId;
                            this.claim.rejectionLetterFileId =
                                response.rejectionLetterFileId;
                            this.claim.queryLetterFileId =
                                response.queryLetterFileId;
                            this.claim.resubmissionPodFileId =
                                response.resubmissionPodFileId;
                            this.claim.podFileId = response.podFileId;
                            */
                            this.claim.shortPaymentFormSetText = "";
                            this.claim.decisionTakenNoteText = "";
                            this.claim.shortPaymentActionNoteText = "";
                            this.emitSavedEntity();
                            this.populating = true;
                            this.loadClaim();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        newNoteAdd() {
            this.isLoading = true;
            this.newNoteAdding = true;
            this.$store
                .dispatch("claims/addNote", {
                    claimId: this.claim.id,
                    text: this.newNoteText
                })
                .then(
                    response => {
                        this.claim.notes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newNoteShow = false;
                        this.newNoteText = "";
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newNoteAddingDone);
        },
        newNoteAddingDone() {
            this.newNoteAdding = false;
            this.isLoading = false;
        },
        validUntilDisplay(date) {
            var dateOut = dateToString(date ? new Date(date) : null);
            return dateOut ? dateOut : "Indefinitely";
        },
        //claim file subform handlers--------------------
        savedClaimFile(claimFileIn) {
            var updateIndex = this.claimFiles.findIndex(
                x => x.id == claimFileIn.id
            );
            if (updateIndex > -1)
                this.$set(this.claimFiles, updateIndex, claimFileIn);
            else this.claimFiles.push(claimFileIn);
        },
        deletedClaimFile(claimFileIn) {
            var deletedIndex = this.claimFiles.findIndex(
                x => x.id == claimFileIn.id
            );
            if (deletedIndex > -1)
                this.$delete(this.claimFiles, deletedIndex);
        },
        newClaimFile() {
            var claimFile = new ClaimFile();
            claimFile.id = 0;
            claimFile.claimId = this.claim.id;
            this.loadClaimFileForm(claimFile);
        },
        loadClaimFileForm(claimFile) {
            this.claimFileFormEntity = claimFile;
            this.claimFileFormKey = claimFile.id;
            this.claimFileFormVisible = true;
        },
        closeClaimFileForm() {
            this.claimFileFormKey = null;
            this.claimFileFormVisible = false;
        },
        getUserName(userId) {
            let found = this.users.filter((x) => x.key == userId);
                if(found.length)
                    {
                        return found.map((x) => x.value)[0];
                        }
                else
                    return "";
        },
    }
};
</script>

<style lang="stylus" scoped></style>